"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFoquzInstallScript = void 0;
const getFoquzInstallScript = () => {
    return `<script>
            window.FOQUZ_SDK = {
                widget: {
                    widget_code: 'f5ee670a4eec023995d1d6b48c5a25f9',
                },
                params: {},
            };
            (function (f, o, q, u, z) {
                u = o.createElement('script');
                z = o.getElementsByTagName('script')[0];
                u.async = 1;
                u.src = q + '?t=' + Date.now();
                z ? z.parentNode.insertBefore(u, z) : o.head.appendChild(u);
            })(window, document, 'https://m2.foquz.ru/widgets/poll/widget_new.js');
        </script>`;
};
exports.getFoquzInstallScript = getFoquzInstallScript;
//# sourceMappingURL=install-script.js.map